import React, { useContext, useEffect, useState } from "react";
import { ReactComponent as QuestionIcon } from './img/Question_icon.svg';
import LeftArrow from "../../img/Left_Arrow.svg";
import { useHistory } from "react-router-dom";
import {
  StyledPlatformLabel,
  StyledPlatformsIntContainer,
  StyledGoBack,
  StyledPlatformsSubtitle,
  Title,
  Button3,
  StyledPlatformsList,
  StyledToggleButtonRight,
  StyledToggleButtonLeft,
  StyledAu
} from "./setup.style";
import FixelDataContext from "../../context/FixelDataContext";
import Firebase from "../../services/firebase"
import {formDataWithToken, getHostname, wpUrl} from "../../services/globalService";
import Tooltip from "../utils/Tooltip";

const ConnectPlatforms = () => {
  const history = useHistory();

  const { fullFixelData, setFullFixelData } = useContext(FixelDataContext);
  const [platformsStatus, setPlatformsStatus] = useState({ ua: '', gapi: false, ms: false, pt: false });
  const [showUaInput, setShowUaInput] = useState(platformsStatus.gapi);

  const tooltipContent = `You can find the UA in your google analytics account`;
  const linkLabel = 'store preferences';
  const linkUrl = `https://analytics.google.com`;


  const getPlatformStatus = () => {
    if (fullFixelData && fullFixelData.install_data && fullFixelData.install_data.options) {
      setPlatformsStatus(fullFixelData.install_data.options);
    }
  };

  useEffect(() => {
    getPlatformStatus();
  }, [fullFixelData]);

  useEffect(() => {
    setShowUaInput(platformsStatus.gapi);
  }, [platformsStatus.gapi]);

  const isPlatformActive = (platformName) => {
    return platformsStatus[platformName];
  };

  const handleToggleClick = (platformName, value) => {
    const newPlatformStatus = { ...platformsStatus };
    newPlatformStatus[platformName] = value;
    setPlatformsStatus(newPlatformStatus);
  };

  const toggleButton = (platformName) => {
    return (
      <div>
        <StyledToggleButtonLeft onClick={() => handleToggleClick(platformName, true)} value={isPlatformActive(platformName)}>
          On
        </StyledToggleButtonLeft>
        <StyledToggleButtonRight onClick={() => handleToggleClick(platformName, false)} value={!isPlatformActive(platformName)}>
          Off
        </StyledToggleButtonRight>
      </div>
    );
  };

  const modifyPlatforms = async () => {
    const newFullFixelData = { ...fullFixelData };
    try {
      const args = JSON.stringify({
          display: getHostname(window.location.hostname),
          email: Firebase.getCurrentUserMail(),
          "install_data" :{
            type: 'WORDPRESS',
            options: {...platformsStatus}
          }
      })
      const response = await formDataWithToken(wpUrl, {
        action: 'fxl_edit_platforms',
        data: args
      });
      if(process.env.NODE_ENV !== 'production') {
        console.log("modifyPlatforms res", response.data || response);
      }
      newFullFixelData.install_data.options = platformsStatus;
      setFullFixelData(newFullFixelData);
      history.push("/setup");
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <StyledPlatformsIntContainer>
      <StyledGoBack onClick={() => history.goBack()}>
        <img src={LeftArrow} alt="arrow left" /> Go Back
      </StyledGoBack>
      <Title align="left">Reach high value&nbsp;users, wherever&nbsp;they are</Title>
      <StyledPlatformsSubtitle>Fixel automagically integrates with your favorite ad platforms for creating high value audiences.</StyledPlatformsSubtitle>
      <StyledPlatformsList>
        <li key='gapi'>
          <StyledPlatformLabel>
            Google Analytics
            <span>
              {' ('}for Google Ads{')'}
            </span>
          </StyledPlatformLabel>
          {toggleButton('gapi')}
        </li>
        {showUaInput ? (
            <li key='gapiUa'>
              <StyledAu>
                <label htmlFor='ua'>
                  Paste your Google Analytics UA
                  <span>*</span>
                  <Tooltip content={tooltipContent} linkLabel={linkLabel} linkUrl={linkUrl}>
                    <QuestionIcon />
                  </Tooltip>
                </label>
                <input onChange={(e) => handleToggleClick('ua', e.target.value)} value={platformsStatus.ua} type='text' name='ua' id='ua' />
              </StyledAu>
            </li>
        ) : null}
        <li>
          <StyledPlatformLabel>Facebook Ads</StyledPlatformLabel>
          {toggleButton("fb")}
        </li>
        <li>
          <StyledPlatformLabel>Pinterest Ads</StyledPlatformLabel>
          {toggleButton("pt")}
        </li>
        <li>
          <StyledPlatformLabel>
            Microsoft Ads {"("}formerly Bing Ads{")"}
          </StyledPlatformLabel>
          {toggleButton("ms")}
        </li>
      </StyledPlatformsList>
      <Tooltip content={platformsStatus.gapi && !platformsStatus.ua ? 'Google Analytics requires UA number' : null}>
        <Button3 onClick={modifyPlatforms} disabled={platformsStatus.gapi && !platformsStatus.ua}>
          Save
        </Button3>
      </Tooltip>
    </StyledPlatformsIntContainer>
  );
};
export default ConnectPlatforms;
